<template>
  <v-card :key="bundle.returnReport.id + bundle.returnReport.paper.id"
          elevation="1"  
          rounded
          class="mb-2 pa-1"           
  >  
    <v-row dense class="ma-1">
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ bundle.returnReport.paper.title }}
        </v-col>        
        <v-col cols="3" class="text-uppercase font-weight-bold align-self-center">
          <template v-if="bundle.returnReport.paper.type === 1">
            {{ bundle.returnReport.paper.edition }}
          </template>          
          <div v-if="bundle.returnReport.paper.description" class="v-messages">
            {{ bundle.returnReport.paper.description }}
          </div> 
        </v-col>        
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ bundle.returnReport.paper.deliveryDate|longPaperDate }} 
        </v-col>
        <v-col cols="1" class="align-self-center">
          {{ bundle.id }} 
        </v-col>
        <v-col cols="1" class="align-self-center">
          {{ bundle.returnReport.returnAmount }}
        </v-col>
        <v-col cols="1" class="align-self-center">
          {{ bundle.returnReport.paper.deliveredAmount }}
        </v-col>
        <v-col cols="2" class="align-self-center">
          <template v-if="bundle.returnReport.paper.deliveryNoteAmount !== null">
            Följesedel:{{ bundle.returnReport.paper.deliveryNoteAmount }} Mottagit:{{ bundle.returnReport.paper.receivedAmount }}
          </template>
        </v-col>        
        <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />         -->
      </template>
      <template v-else>
        <v-container>
          <v-row dense class="text-uppercase align-self-center">
            <v-col cols="8" justify="end">
              <span class="font-weight-bold">{{ bundle.returnReport.paper.title }} <template v-if="bundle.returnReport.paper.type === 1">{{ bundle.returnReport.paper.edition }}</template></span>      
              <v-row v-if="bundle.returnReport.paper.description" dense>
                <v-col cols="12" justify="end" class="">
                  {{ bundle.returnReport.paper.description }}                             
                </v-col>            
              </v-row>                      
            </v-col>            
            <v-col cols="4">             
              <span class="font-weight-bold">{{ bundle.returnReport.paper.deliveryDate|paperDate }} </span>         
            </v-col>
          </v-row>
          <v-row dense class="text-uppercase align-self-center">
            <v-col cols="8">
              Retur: <span class="font-weight-bold">{{ bundle.returnReport.returnAmount }}         </span>
            </v-col>
            <v-col cols="4">              
              Bunt nr:<span class="font-weight-bold"> {{ bundle.id }} </span>
            </v-col>
          </v-row>
          <v-row v-if="bundle.returnReport.paper.deliveryNoteAmount !== null" dense>
            <v-col cols="3" class="text-uppercase align-self-center">
              Reklamerat:
            </v-col>
            <v-col cols="9">
              Följesedel:{{ bundle.returnReport.paper.deliveryNoteAmount }} - Mottagit:{{ bundle.returnReport.paper.receivedAmount }}
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-row>             
  </v-card>
</template>

<script>
export default {
  name: 'BundleHistoric', 
   props: {
    bundle: {
      type: Object,
      required: true,
    }
  },       
}
</script>